import React from "react";
import { styled } from "@mui/system";
import { Typography } from "@mui/material";

const StyledLabel = styled(Typography)({
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#443F3F",
});

const StyledValue = styled(Typography)({
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  // textAlign: "center",
});
const StyledTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: "30px",
  lineHeight: "45px",
  marginTop: "10px",
});
const StyledTableCellTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "15.5px",
  whiteSpace: "nowrap",
  textAlign: "center",
});
const StyledTableCellValue = styled(Typography)({
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "15.5px",
  whiteSpace: "nowrap",
  textAlign: "center",
});

const StyledChartsTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: "13px",
  lineHeight: "16.5px",
});

const StyledTitleLabel = styled(Typography)({
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "15.5px",
  overflowWrap: "break-word",
  // wordBreak: "break-all",
  padding: "0 8px",
  marginTop: "5px",
});
const StyledSubtitle = styled(Typography)({
  fontWeight: 400,
  fontSize: "11.5px",
  lineHeight: "15.5px",
  overflowWrap: "break-word",
  // wordBreak: "break-all",
  padding: "0 8px",

  textAlign: "center",
});

const StyledTransactionTableValues = styled(Typography)({
  fontWeight: 400,
  fontSize: "10px",
  lineHeight: "12px",
});

const CustomLabel = ({ children }) => {
  return <StyledLabel>{children}</StyledLabel>;
};

const CustomValue = ({ children }) => {
  return <StyledValue>{children}</StyledValue>;
};
const CustomTitle = ({ children }) => {
  return <StyledTitle>{children}</StyledTitle>;
};
const CustomTableCellTitle = ({ children }) => {
  return <StyledTableCellTitle>{children}</StyledTableCellTitle>;
};
const CustomTableCellValue = ({ children }) => {
  return <StyledTableCellValue>{children}</StyledTableCellValue>;
};
const CustomChartsTitle = ({ children }) => {
  return <StyledChartsTitle>{children}</StyledChartsTitle>;
};

const CustomSubtitle = ({ children }) => {
  return <StyledSubtitle>{children}</StyledSubtitle>;
};
const CustomTitleLabel = ({ children }) => {
  return <StyledTitleLabel>{children}</StyledTitleLabel>;
};

const CustomTransactionTableValues = ({ children }) => {
  return (
    <StyledTransactionTableValues>{children}</StyledTransactionTableValues>
  );
};

export {
  CustomLabel,
  CustomValue,
  CustomTitle,
  CustomTableCellTitle,
  CustomTableCellValue,
  CustomChartsTitle,
  CustomSubtitle,
  CustomTitleLabel,
  CustomTransactionTableValues,
};
